import React, { useEffect } from 'react';
import './App.css';
import { DeepPresets } from './components/deepPresets';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "@mantine/core/styles.css";
import { MantineProvider } from "@mantine/core";
import 'react-calendar/dist/Calendar.css';
import ExportTokensMcapPage from './components/mcapTokenExport';
import DevsMcapReportPage from './components/devsMcapReport';
import RobinhoodPresets from './components/robinhoodPresets';
import BnbPresets from './components/bnbPresets';

// Глобальный компонент для предзагрузки SVG-иконок
const PreloadIcons: React.FC = () => {
  useEffect(() => {
    const icons = [
      '/icons/dex/raydium.svg',
      '/icons/dex/meteora.svg',
      '/icons/dex/PumpFun.svg',
      '/icons/aggregators/ApePro.svg',
      '/icons/aggregators/JUP6.svg',
      '/icons/aggregators/OKX_Router_v2.svg',
      '/icons/aggregators/RayAmmRouter.svg',
      // Добавьте сюда другие SVG пути по мере необходимости
    ];
    icons.forEach(src => {
      const img = new window.Image();
      img.src = process.env.PUBLIC_URL + src;
    });
  }, []);
  return null;
};

function App() {
  return (
      <BrowserRouter>
        <PreloadIcons />
        <Routes>
          <Route path="/deep/filters" element={
            <div className="App" style={{ height: '100%' }}>
              <MantineProvider>
                <DeepPresets />
              </MantineProvider>
          </div>
            } />
          <Route path="/export/tokens/mcap" element={
            <div className="TokenMcapExport" style={{ height: '100%' }}>
              <MantineProvider>
                <ExportTokensMcapPage />
              </MantineProvider>
          </div>
            } />
          <Route path="/export/devs/mcap_report" element={
            <div className="DevsMcapReport" style={{ height: '100%' }}>
              <MantineProvider>
                <DevsMcapReportPage />
              </MantineProvider>
          </div>
            } />
          <Route path="/robinhood/filters" element={
            <div className="RobinhoodFilters" style={{ minHeight: '100%' }}>
              <RobinhoodPresets />
            </div>
          } />
          <Route path="/bnb/filters" element={
            <div className="BnbFilters" style={{ minHeight: '100%' }}>
              <BnbPresets />
            </div>
          } />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
